import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { IFormActions } from 'src/app/shared/interfaces/IForm';

@Component({
  selector: 'app-form-button',
  standalone: true,
  imports: [CommonModule, MaterialModule, TranslateModule, TablerIconsModule],
  templateUrl: './form-button.component.html',
  styleUrl: './form-button.component.scss'
})
export class FormButtonComponent {
  @Input() btnConfig: IFormActions;
  @Input() spinLoader: boolean;

  get ButtonText(): string {
    if (typeof this.btnConfig.text === 'function') {
      return this.btnConfig.text();
    }
    return this.btnConfig.text;
  }
}
